import { Apis } from '@data-access';
import { APIHelper } from '@helpers';
import { action, makeObservable, observable } from 'mobx';
import { LimitsType } from 'src/pages/settings';

export class SettingsStore {
  riskLimits: LimitsType | null = null;

  constructor() {
    makeObservable(this, {
      riskLimits: observable,
      setRiskLimits: action.bound,
      initializeRiskLimits: action.bound,
    });
  }

  async initializeRiskLimits() {
    // initialize risk limits with existing limits
    let apis: Apis;
    try {
      const config = await APIHelper.createApiConfiguration();
      apis = APIHelper.createApisFromConfig(config);
    } catch (error) {
      console.log(error);
    }

    try {
      const response = await apis?.api.apiSettingsList();
      if (!response?.results) return;
      const [firstResult] = response.results;
      this.riskLimits = firstResult;
    } catch (error) {
      console.log(error);
    }
  }

  setRiskLimits = (limits: LimitsType) => {
    if (limits) {
      this.riskLimits = limits;
    }
  };
}

export const settingsStore = new SettingsStore();
